import React, { useEffect, useState } from 'react'
import { IconClose } from '@Knowledge-OTP/znk-ui-components'
import './index.css'

const SelectionActionBar = ({
  count,
  label,
  selection,
  onClear,
  actions = [],
  floating = false,
  bottomCentered = false,
  className = '',
  clearLabel = 'Clear selection',
  // Mobile layout (design system): full-width bar in the thumb zone,
  // close + count on the left, vertical icon/label buttons on the right.
  mobile = false
}) => {
  const [animationKey, setAnimationKey] = useState(0)

  useEffect(() => {
    setAnimationKey((key) => key + 1)
  }, [selection, count])

  if (!count) return null

  if (mobile) {
    return (
      <div key={animationKey} className={`selection-action-bar selection-action-bar-mobile selection-action-bar-bounce ${className}`}>
        <button type='button' className='selection-action-bar-mobile-clear' aria-label={clearLabel} onClick={onClear}>
          <IconClose size={13} />
        </button>
        <span className='selection-action-bar-count' aria-label={label}>{count}</span>
        <span className='selection-action-bar-mobile-spacer' />
        {actions.map(({ key, Icon, label: actionLabel, onClick, variant = '', disabled = false, title }, index) => (
          <button
            key={key || `${actionLabel}-${index}`}
            type='button'
            className={`selection-action-bar-mobile-action${variant ? ` selection-action-bar-mobile-action-${variant}` : ''}`}
            onClick={onClick}
            disabled={disabled}
            title={disabled ? title : undefined}
          >
            {Icon && <Icon size={18} style={{ width: 18, height: 18 }} />}
            <span>{actionLabel}</span>
          </button>
        ))}
      </div>
    )
  }

  return (
    <div key={animationKey} className={`selection-action-bar selection-action-bar-bounce${floating ? ' selection-action-bar-floating' : ''}${bottomCentered ? ' selection-action-bar-bottom-centered' : ''} ${className}`}>
      <div className='selection-action-bar-summary'>
        <span className='selection-action-bar-count'>{count}</span>
        <span className='selection-action-bar-label'>{label}</span>
        <button type='button' className='selection-action-bar-clear' aria-label={clearLabel} onClick={onClear}>
          <IconClose size={12} />
        </button>
      </div>
      <div className='selection-action-bar-actions'>
        {actions.length > 0 && <span className='selection-action-bar-divider' aria-hidden='true' />}
        {actions.map(({ key, Icon, label: actionLabel, onClick, variant = '', disabled = false, title }, index) => (
          <React.Fragment key={key || `${actionLabel}-${index}`}>
            <span
              className={`selection-action-bar-action-wrapper${disabled && title ? ' has-tooltip' : ''}`}
              data-tooltip={disabled && title ? title : undefined}
            >
              <button
                type='button'
                className={`selection-action-bar-action${variant ? ` selection-action-bar-action-${variant}` : ''}`}
                onClick={onClick}
                disabled={disabled}
              >
                {Icon && <Icon size={variant === 'edit' ? 14 : 11} style={{ width: variant === 'edit' ? 14 : 11, height: variant === 'edit' ? 14 : 11 }} />}
                <span>{actionLabel}</span>
              </button>
            </span>
            <span className='selection-action-bar-divider' aria-hidden='true' />
          </React.Fragment>
        ))}
      </div>
    </div>
  )
}

export default SelectionActionBar
